/* @flow weak */
import { getStyle } from 'lib/DOM';

function isFixed(node) {
  while (node && node !== document.body) {
    const position = getStyle(node, 'position');
    if (position === 'fixed') {
      return true;
    }
    node = node.parentNode; // eslint-disable-line no-param-reassign
  }
  return false;
}

export default isFixed;
